import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';

import {
  ClaimDocumentTypesPartialState,
  ClaimDocumentType
} from './claim-document-types.reducer';
import {
  LoadClaimDocumentTypes,
  LoadClaimDocumentTypesSuccess,
  LoadClaimDocumentTypesFail,
  ClaimDocumentTypesActionTypes
} from './claim-document-types.actions';
import { ClaimDocumentTypesService } from '../claim-document-types.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClaimDocumentTypesEffects {
  @Effect() loadClaimDocumentTypes$ = this.dataPersistence.fetch(
    ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES,
    {
      run: (
        action: LoadClaimDocumentTypes,
        state: ClaimDocumentTypesPartialState
      ) => {
        // Your custom REST 'load' logic goes here. For now just return an empty list...
        return this.service
          .get()
          .pipe(
            map(
              (claimDocumentTypes: ClaimDocumentType[]) =>
                new LoadClaimDocumentTypesSuccess(claimDocumentTypes)
            )
          );
      },

      onError: (action: LoadClaimDocumentTypes, error) => {
        
        return new LoadClaimDocumentTypesFail(error);
      }
    }
  );

  constructor(
    private actions$: Actions,
    private dataPersistence: DataPersistence<ClaimDocumentTypesPartialState>,
    private service: ClaimDocumentTypesService
  ) {}
}
